<template>
<div class="schedule section" id="schedule">
  <div :class="{'layout-content': isMobile}">
    <SubTitle :text="title" :subText="subText" />

    <div class="content-bg" />

    <div class="layout-content">
      <p class="note">{{data.subTitle}}</p>
    </div>
  </div>
  </div>
</template>

<script>
import SubTitle from '@/components/SubTitle'

import { mapState } from 'vuex'

export default {
  props: ['data'],
  components: {
    SubTitle
  },
  computed: {
    ...mapState(['isMobile', 'isEnLang']),
    title () {
      return this.isEnLang ? 'AGENDA' : '大赛日程'
    },
    subText () {
      return this.isEnLang ? 'FINTECHATHON' : 'AGENDA'
    }
  }
}
</script>

<style lang="scss" scoped>

.schedule {
  height: 600px;
  background: url('https://static001.geekbang.org/resource/image/6a/c1/6a8370357eba06e23f74a4f6bb19c3c1.png') center / cover no-repeat;

  @include mobile {
    height: 576px;
    padding-top: 41px;
    background: url('https://static001.geekbang.org/resource/image/f2/a7/f2356f01e527f0ddf049661975b772a7.png') center / cover no-repeat;
  }
}

.content-bg {
  height: 246px;
  background: url('https://static001.geekbang.org/resource/image/9c/57/9c9bfff0f38810975a8c824dcf4b3457.png') center / cover no-repeat;

  @include mobile {
    width: 297px; height: 376px;
    margin: 25px 0 0 5px;
    background: url('https://static001.geekbang.org/resource/image/69/f8/692ffebf0ab391b62ab229e5840292f8.png') center / cover no-repeat;
  }
}

.note {
  padding-top: 68px;
  text-align: center;
  color: #828A93;

  @include mobile {
    display: none;
  }
}

</style>
